// removed by extract-text-webpack-plugin
module.exports = {"index":"_1C28j2e3dkJupCjgLX32vt","black":"_1by0C1uqowz5gfT2xSHcXH","title":"_1s-QUL89GlY-OZv2r6fLjX","text":"_7YoRIkAKncCaCnSMilWeF","logoWrapper":"_2vCjTL7hpjAAd0tmjy7Y2B","logoWrapperImg":"_4TM06f-roKj6b1ohMbkZs","logo":"_7UFHIiAUVZ_l4rmmG0lK5"};


//////////////////
// WEBPACK FOOTER
// ./src/blocks/Title/index.css
// module id = 246
// module chunks = 0